// Structures FSE pour lots (FSE/DRE) et PJs

// AF extraireFacturesJamaisMisesEnLot structures
export interface ExtractFacturesHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
		extractFactures: ExtractFactures;
	};
};

export interface ExtractFactures {
	facture: Facture[];
}

export interface Facture { // Represents an invoice
  numFacture: string // Invoice number
  dateFacture: string // Invoice creation date
  typeFacture: string // Type of flux: FSE_INITIALE, DRE_INTIIALE, DRE_ANNULATION
  etatFacture: string // Invoice state
  dateHeureEtatFacture: string // Date of the last state change of the invoice
}

// AF extraireLots structures
export interface extractLotsHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
		extractLots: ExtractLots;
	};
};

export class ExtractLots { // Represents the list of extracted lots
  dateHeureGeneration: string // Date of generation of the list (to be passed on the next call)
  lot: Lot[] // List of lots

  constructor(dateHeureGeneration: string, lot: Lot[]) {
    this.dateHeureGeneration = dateHeureGeneration;
    this.lot = lot;
  }
}

export interface Batch {	// Table fse_batch
	id: number;
	ref_lot?: string;
	date_lot?:Date;
	top_dre?: string;
	num_ident_fact?: string;
	num_ident_signataire?: string;
	num_orga_dest?: string;
	etat_lot?: string;
	date_heure_etat_lot?:Date;
	diag_anomalie?: string;
	trait_anomalie?: string;
}

export class Lot { // Represents a lot
	id: number=0;		// Just used to be sent to API without a nulml
  refLot: string // Lot number
  dateLot: string // Lot creation date
  topDRE: string // Type of lot: DRE or FSE
  numIdentFact: string // Billing identifier
  numIdentSignataire: string // Billing identifier of the lot signatory
  numOrgaDest?: string // Destination organization's number (only present in the case of an FSE lot)
  etatLot: string // Lot state
  dateHeureEtatLot: string // Date of the last state change of the lot
  diagAnomalie?: string // Diagnostic of the anomaly in the lot transmission
  traitAnomalie?: string // State of anomaly processing
  facture: Facture[] // List of invoices

  constructor(
		id:number,
    refLot: string,
    dateLot: string,
    topDRE: string,
    numIdentFact: string,
    numIdentSignataire: string,
    etatLot: string,
    dateHeureEtatLot: string,
    facture: Facture[],
    numOrgaDest?: string,
    diagAnomalie?: string,
    traitAnomalie?: string
  ) {
		this.id=id,
    this.refLot = refLot
    this.dateLot = dateLot
    this.topDRE = topDRE
    this.numIdentFact = numIdentFact
    this.numIdentSignataire = numIdentSignataire
    this.numOrgaDest = numOrgaDest
    this.etatLot = etatLot
    this.dateHeureEtatLot = dateHeureEtatLot
    this.diagAnomalie = diagAnomalie
    this.traitAnomalie = traitAnomalie
    this.facture = facture
  }
}

// Define the object structure for each cell in the bi-dimensional array
interface BatchFSEInfo {
  explication: string; // Corresponds to Column 5
  action: string; // Corresponds to Column 6
  traitementAnomalie: string | null; // Corresponds to Column 3 (nullable if absent)
}

// Create the bi-dimensional constant array: Batch state X FSE state
export const BatchFSEMap: Record<string, Record<string, BatchFSEInfo>> = {
		NULL: {
	  NOUVELLE: {
	    explication: "Facture créé en attente de mise en lot",
	    action: "Mettre la facture en lot",
	    traitementAnomalie: null
	  },
		ERROR: {
		  explication: "Facture créé en erreur",
		  action: "Corriger la facture",
		  traitementAnomalie: null
		}		
	},	
  LOT: {
    LOT: {
      explication: "Lot créé en attente de mis en fichier",
      action: "so",
      traitementAnomalie: null
    }
  },
  FICHIER: {
    FICHIER: {
      explication: "Lot en fichier en attente de télétransmission",
      action: "so",
      traitementAnomalie: null
    }
  },
  EXPEDIE: {
    EXPEDIE: {
      explication: "Lot télétransmis",
      action: "so",
      traitementAnomalie: null
    }
  },
  REEXPEDIE: {
    REEXPEDIE: {
      explication: "Lot télétransmis. Le lot est constitué de factures qui font l'objet d'un deuxième envoi (rentransmission du lot à l'identique ou reconstitution d'un lot)",
      action: "so",
      traitementAnomalie: null
    }
  },
  ACHEMINE: {
    ACHEMINE: {
      explication: "Lot télétransmis + réception d'un avis de remise",
      action: "so",
      traitementAnomalie: null
    }
  },
  ARL_POSITIF: {
    ARL_POSITIF: {
      explication: "Lot ayant reçu un ARL positif (hors lot FSE dégradées)",
      action: "so",
      traitementAnomalie: null
    }
  },
  RSP: {
    RSP: {
      explication: "Lot ayant au moins une facture pour laquelle un RSP a été reçu + Facture concernée par un RSP",
      action: "so",
      traitementAnomalie: null
    },
    EXPEDIE: {
      explication: "Lot ayant au moins une facture pour laquelle un RSP a été reçu + Facture non concernée par un RSP",
      action: "so",
      traitementAnomalie: null
    },
    ACHEMINE: {
      explication: "Lot ayant au moins une facture pour laquelle un RSP a été reçu + Facture non concernée par un RSP",
      action: "so",
      traitementAnomalie: null
    },
    ACQUITTE: {
      explication: "Lot ayant au moins une facture pour laquelle un RSP a été reçu + Facture non concernée par un RSP",
      action: "so",
      traitementAnomalie: null
    },
    ARL_POSITIF: {
      explication: "Lot ayant au moins une facture pour laquelle un RSP a été reçu + Facture non concernée par un RSP",
      action: "so",
      traitementAnomalie: null
    }
  },
  ACQUITTE: {
    ACQUITTE: {
      explication: "Lot FSE dégradées télétransmis ne faisant pas l'objet de rejet technique ou d'avis de non remise dans les 48h suivant la télétransmission",
      action: "so",
      traitementAnomalie: null
    }
  },
  ARL_NEGATIF: {
    ARL_NEGATIF_A_TRAITER: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) pour lequel un ARL négatif a été reçu",
      action: "Le PS peut choisir de reconstituer un lot composé des mêmes factures exceptée une éventuellement facture en anomalie OU de traiter manuellement (papier) l'ensemble des factures qui le composent",
      traitementAnomalie: "ACTION_PS"
    },
    ERREUR: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) pour lequel un ARL négatif a été reçu + la facture est clairement indiquée comme en anomalie",
      action: "La facture en anomalie doit être traitée manuellement + le PS peut chosir de reconstituer un lot composé des mêmes factures exceptée cette facture en erreur OU de traiter manuellement (papier) l'ensemble des factures qui le composent",
      traitementAnomalie: "ACTION_PS"
    },
    REFAIRE_LOT: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) pour lequel un ARL négatif a été reçu",
      action: "Le PS a choisi de reconstituer un lot composé des mêmes factures exceptée une éventuellement facture en erreur",
      traitementAnomalie: "REFAIRE_LOT_PS"
    },
    MANUEL: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) pour lequel un ARL négatif a été reçu + la facture est clairement indiquée comme en anomalie",
      action: "Le PS a choisi de traiter manuellement (papier) les factures qui le composent ; il peut revenir sur son choix et reconstituer un lot composé des mêmes factures exceptée une éventuellement facture en erreur",
      traitementAnomalie: "TRAITEMENT_MANUEL_PS"
    },
    MANUEL_OBLIGATOIRE: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) pour lequel un ARL négatif a été reçu OU Lot pour lequel un ARL négatif empêchant la réémission a été reçu OU Lot composé d'un seule facture pour le quel un ARL négatif indiquant que cette facturé est en erreur a été reçu",
      action: "Les factures doivent être traitées manuellement (papier)",
      traitementAnomalie: "TRAITEMENT_MANUEL_OBLIGATOIRE"
    }
  },
  AR_PROVISOIRE: {
    AR_PROVISOIRE: {
      explication: "Lot faisant l'objet d'un Accusé de Réception Provisoire",
      action: "Le PS doit attendre ; si dans un délai de 15j aucun ARL positif ou négatif n'est reçu, le lot passera en état ABSENCE_ARL_MANUEL_OBLIGATOIRE",
      traitementAnomalie: "ATTENTE"
    }
  },
  ABSENCE_ARL_MANUEL_OBLIGATOIRE: {
    MANUEL_OBLIGATOIRE: {
      explication: "Lot composé de factures faisant l'objet d'une réémission (hors lot FSE dégradées) n'ayant pas reçu d'ARL après 48h OU Lot n'ayant pas reçu d'ARL 15 jours après la réception d'un ARP",
      action: "Les factures doivent être traitées manuellement (papier)",
      traitementAnomalie: "TRAITEMENT_MANUEL_OBLIGATOIRE"
    }
  },
  ABSENCE_ARL_RENVOYER_LOT: {
    RENVOYER_LOT: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission (hors lot FSE dégradées) n'ayant pas reçu d'ARL après 48h",
      action: "Le lot sera automatiquement remis dans la chaîne de traitement lors de la prochaine mise en fichier",
      traitementAnomalie: "RENVOI_AUTOMATIQUE"
    }
  },
  DSN: {
    RENVOYER_LOT: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission pour lequel un avis de non remise a été reçu",
      action: "Le lot sera automatiquement remis dans la chaîne de traitement lors de la prochaine mise en fichier",
      traitementAnomalie: "RENVOI_AUTOMATIQUE"
    },
    MANUEL_OBLIGATOIRE: {
      explication: "Lot composé de factures faisant l'objet d'une réémission pour lequel un avis de non remise a été reçu",
      action: "Les factures doivent être traitées manuellement (papier)",
      traitementAnomalie: "TRAITEMENT_MANUEL_OBLIGATOIRE"
    }
  },
  REJETE: {
    RENVOYER_LOT: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission pour lequel un rejet technique (code différent de 3xxx) a été reçu",
      action: "Le lot sera automatiquement remis dans la chaîne de traitement lors de la prochaine mise en fichier",
      traitementAnomalie: "RENVOI_AUTOMATIQUE"
    },
    ARL_NEGATIF_A_TRAITER: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission pour lequel un rejet technique (code 3xxx uniquement) a été reçu",
      action: "Le PS peut choisir de reconstituer un lot composé des mêmes factures OU de traiter manuellement (papier) l'ensemble des factures qui le composent",
      traitementAnomalie: "ACTION_PS"
    },
    REFAIRE_LOT: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission pour lequel un rejet technique (code 3xxx uniquement) a été reçu",
      action: "Le PS a choisi de reconstituer un lot composé des mêmes factures",
      traitementAnomalie: "REFAIRE_LOT_PS"
    },
    MANUEL: {
      explication: "Lot composé de factures NE faisant PAS l'objet d'une réémission pour lequel un rejet technique (code 3xxx uniquement) a été reçu",
      action: "Le PS a choisi de traiter manuellement (papier) les factures qui le composent",
      traitementAnomalie: "TRAITEMENT_MANUEL_PS"
    },
    MANUEL_OBLIGATOIRE: {
      explication: "Lot composé de factures faisant l'objet d'une réémission pour lequel un rejet technique a été reçu",
      action: "Les factures doivent être traitées manuellement (papier)",
      traitementAnomalie: "TRAITEMENT_MANUEL_OBLIGATOIRE"
    }
  }
};

// AF extraireScore structures
export interface ExtractScoreHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
		extractSCOR: ExtractSCOR;
	};
};

export interface ExtractSCOR { // Represents the list of extracted SCOR data
  dateHeureGeneration: string; // Date of generation of the list (to be passed on the next call)
  dossier: Dossier[]; // List of dossiers
}

export interface Dossier {
	numFacture: string;
	numIdentFact: string;
	dateFacture: string;
	index: string;
	reference: string;
	codeAction: string;
	etatDossier: string;
	dateHeureEtatDossier: string;
	diagnostic: string;
	PJ: PJ[];
}

// AF AjouterPJ Response structures
export interface AjouterPJHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
		PJ: PJ;
	};
};

export interface PJ {
	nature: string;
	idFactResponsable: string;
	dateConstitution: string;
	type: string;
	idPJ: string|undefined;
	contenu: string|undefined;
}

// AF AjouterPJ Response structures
export interface SupprimerHTTPResponse {
	HTTPResponse: {
		codeRetour: string,
		libRetour: string,
		idSession: string,
	};
};

export const DOC_NATURE_OPTIONS: { [key: string]: string } = {
  "ORDN": "Prescription",
  "FSNC": "Feuille de soin papier",
  "OGA": "Ordonnance GAO",
  "DLIT": "Devis Lit",
  "DORT": "Devis Orthèses",
  "DVIS": "Devis verres iséiconiques",
  "DAUD": "Devis audioprothèses",
  "DPOF": "Devis prothèses oculaires et faciales",
  "DPOD": "Devis podo-orthèses",
  "DOPT": "Devis Ortho prothèses",
  "DAUT": "Devis non prévu dans ce tableau",
  "FDSC": "Facture détaillée Maintenance curative lit",
  "FDCL": "Facture détaillée Maintenance curative lit",
  "FDPH": "Facture détaillée Photothérapie",
  "FDRV": "Facture détaillée Réparations VPH",
  "FDAU": "Facture détaillée autre",
  "FRCS": "Facture R 165-25 css",
  "FFRP": "Facture Forfait réparation processeur implant cochléaire",
  "FPFA": "Facture Prothèses faciales",
  "FFEP": "Facture Expédition podo-orthèse",
  "FRDE": "Facture Renouvellement double emboîture bras/av-bras",
  "FAUT": "Facture ou feuille de soins non prévue dans ce tableau",
  "AUTP": "PJ non prévue dans ce tableau",
};

export const ETATDOSSIER: { [key: string]: { lib: string; icon?: string } } = {
  NEW: {
    lib: "État initial du dossier SCOR.",
    icon: undefined,
  },
  LOT: {
    lib: "Le dossier SCOR est rattaché à un lot SCOR.",
    icon: undefined,
  },
  A_TRANSMETTRE: {
    lib: "Le dossier SCOR est en attente d'envoi.",
    icon: undefined,
  },
  EMIS: {
    lib: "Le dossier SCOR a été transmis et n'a pas encore fait l'objet d'un ARL.",
    icon: undefined,
  },
  EMIS_ATTENTE: {
    lib: "Le dossier SCOR a fait l'objet d'un AR_P (accusé de réception provisoire) et n'a pas encore fait l'objet d'un ARL.",
    icon: undefined,
  },
  A_RECONSTITUER: {
    lib: "Le dossier SCOR a fait l'objet d'un premier ARL- ou la FSE correspondante doit être remise en lot. Il doit être réaffecté à un nouveau lot SCOR.",
    icon: undefined,
  },
  RECONSTITUE: {
    lib: "Le dossier SCOR a été affecté à un second lot suite à une reconstitution de lot.",
    icon: undefined,
  },
  A_RETRANSMETTRE: {
    lib: "Le dossier SCOR est en attente de son second envoi.",
    icon: undefined,
  },
  RETRANSMIS: {
    lib: "Le dossier SCOR a été transmis une seconde fois et n'a pas encore fait l'objet d'un ARL.",
    icon: undefined,
  },
  REEMIS_ATTENTE: {
    lib: "Le dossier SCOR a fait l'objet d'un AR_P(accusé de réception provisoire), suite à son seond envoir. Il n'a pas encore fait l'objet d'un ARL.",
    icon: undefined,
  },
  ARCHIVE: {
    lib: "Le dossier SCOR a fait l'objet d'un ARL positif.",
    icon: undefined,
  },
  A_TRAITER_MANUELLEMENT_PAPIER: {
    lib: "Le dossier SCOR doit faire l'objet d'un traitement papier. Le PS n'a pas encore valider la notification sur l'IHM AreaFSE.",
    icon: undefined,
  },
  COLLECTE_PAPIER: {
    lib: "Le dossier SCOR doit faire l'objet d'un traitement papier. Le PS a validé la notification sur l'IHM AreaFSE.",
    icon: undefined,
  },
  A_TRAITER_MANUELLEMENT_CD: {
    lib: "Le dossier SCOR doit faire l'objet d'un traitement CD-Rom. Le PS n'a pas encore valider la notification sur l'IHM AreaFSE.",
    icon: undefined,
  },
  SAUVEGARDE_POUR_CD: {
    lib: "Le dossier SCOR doit faire l'objet d'un traitement CD-Rom. Le PS n'a pas encore valider la notification sur l'IHM AreaFSE, mais n'a pas encore généré l'image disque correspondante.",
    icon: undefined,
  },
  ARCHIVE_CD: {
    lib: "Le dossier SCOR doit faire l'objet d'un traitement CD-Rom. Le PS a généré l'image disque correspondante.",
    icon: undefined,
  },
};

export const CODEACTION: { [key: string]: { lib: string; icon?: string } } = {
  EN_COURS: {
    lib: "Le dossier est en cours de traitement. Aucune action spécifique n'est attendue",
		icon: undefined,
  },
  RECU_AMO: {
    lib: "Le dossier a fait l'objet d'un ARL+. Si la FSE correspondante a également fait l'objet d'un ARL positif, cet état n'évoluera plus. Sinon le dossier peut repasser dans un des 3 autres états",
		icon: undefined,
  },
  A_IMPRIMER: {
    lib: "Le dossier de PJ fait l'objet d'un traitement papier. Il convient de prévoir l'impression depuis le LG",
		icon: undefined,
  },
  A_GRAVER: {
    lib: "Le dossier de PJ fait l'objet d'un traitement CD-ROM",
		icon: undefined,
  }
};